const getHostUrl = () => {
  const host = window.location.host;
  const protocol = window.location.protocol;
  return `${protocol}//${host}`;
};

export default getHostUrl;
